<template>
  <div @drop.stop="drop">
   <v-text-field
      v-model="value"
      :label="label"
      multi-line
      :rules="rules"
      :required="required"
    />

    <div class="text-xs-center">
      <input type="file" ref="file" @change="fileChanged" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String,
    name: Boolean,
    required: Boolean
  },
  data () {
    return {
      rules: [
        (value) => {
          if (!value) return true
          return /-----BEGIN PGP PUBLIC KEY BLOCK-----([^]*?)-----END PGP PUBLIC KEY BLOCK-----/.test(value)
            ? true
            : this.$t('configuration.basic.invalidKey')
        }
      ]
    }
  },
  methods: {
    drop (ev) {
      let data = ev.dataTransfer
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile())
            ev.preventDefault()
            break
          }
        }
      } else {
        this.readFile(data.files[0])
        ev.preventDefault()
      }
    },
    fileChanged () {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0])
      }
    },
    readFile (file) {
      let reader = new FileReader()
      reader.onload = () => {
        this.$emit('input', reader.result)
      }
      reader.readAsText(file)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PublicKeyInput.vue?b58ded0e